export default "__VITE_ASSET__jJe3cb6F__"